import api from './api';
import types from './mutation-types';
import moment from 'moment';
import _ from 'lodash';

const dateFormat = ts => {
	return moment(ts).format('YYYY-MM-DD');
};

export default {
	/*
    getTableList_({ commit },params = {tableId, tableNm, colId, colNm, currentPage, pageUnit}) {
		return api
			.getTableList(params)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_OPTION_PLANT_LIST, {
						key: 'value',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
			
	},
	*/
	searchCommCdTypeOptions_({ state, dispatch, commit }) {
		return api
			.selectCommCdTypeList({ ...state.searchParam, currentPage: 0, pageUnit: 0 })
			.then(({ body: { result }, header }) => {
				result.forEach(row => delete row.totalSize);
				dispatch('setCommCdTypeOptions_', result);
				return result;
			})
			.catch(e => console.error(e));
	},
	setCommCdTypeOptions_({ state, commit }, rows) {
		const value = [{ label: 'ALL', value: 'ALL' }].concat(rows.map(({ commCdType }) => ({ label: commCdType, value: commCdType })));
		commit(types.SET, {
			key: 'commCdTypeOptions',
			value
		});
		return value;
	},
	searchCommCd_({ state, commit }, payload) {
		const { commCdType, init, currentPage = 1, pageUnit = 10 } = payload;
		//console.log('searchCommCd_ 시작 ');
		return api
			.selectCommCdList({ commCdType, currentPage, pageUnit })
			.then(({ body: { pagingInfo, result } }) => {
				result.forEach(row => delete row.totalSize);
				commit(types.SET, { key: 'commCdRows', value: init || result });
				commit(types.SET, { key: 'commCdPagingInfo', value: pagingInfo });
				return result;
			})
			.catch(e => console.error(e));
	},
	setUseYnOptions_({ state, commit }, rows) {
		commit(types.SET, {
			key: 'useYnOptions',
			value: [{ label: 'Select', value: '' }].concat(rows.map(({ commCd }) => ({ label: commCd, value: commCd })))
		});
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	onChangeSearchParam_({ commit }, { key, value }) {
		return commit('setSearchParam', { key, value });
	},
	onChangeUserPopupSearchParam_({ commit }, { key, value }) {
		return commit('setUserPopSearchParam', { key, value });
	},

	// setSearchParam_({ commit }, { key, value }) {
	// 	// console.log('actions');
	// 	commit(types.SEARCH_PARAM, {
	// 		key: key,
	// 		value: value !== null && value !== undefined ? value : null
	// 	});
	// },

	// async selectOptions_({ commit }) {
	// 	return api.selectOptions().then(res => {
	// 		const value = res.body.map(({ notiGrpCd, notiGrpDesc }) => ({ label: notiGrpDesc, value: notiGrpCd }));
	// 		commit(types.SET, { key: 'useYnOptions', value });
	// 		return value;
	// 	});
	// },
	getUseYnList_({ commit }, { plantCd }) {
		return api.getUseYnList(plantCd, 'USE_YN').then(res => {
			const value = res.body.map(({ commCd, commCdName }) => ({ label: commCd, value: commCd }));
			commit(types.SET, { key: 'useYnOptions', value });
			return value;
		});
	},
	/*
	select_({ commit, state }, { currentPage, pageUnit }) {
		const { searchParams } = state;
		console.log('::::::: select_ :::::: 함수 시작');
		console.log('::::::: searchParams :::::: ' + searchParams);
		return api
			.select({ searchParams, currentPage, pageUnit })
			.then(data => {
				if (data.header.code === 0 || data.header.code === 200) {
					//commit(types.USER_LIST, data !== null && data !== undefined ? data.body.resultList : null);
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
	*/

	select_({ commit, state: { searchParams, pagingInfo } }, newPagingInfo) {
		//console.log('select_ 함수 시작');
		return api.select({ ...searchParams, ...pagingInfo, ...newPagingInfo }).then(res => {
			const { result, pagingInfo } = res.body;
			//commit('setTableInfoList', result !== null && result !== undefined ? result.resultList : null);
			//console.log('result ::::: ', result);
			/* */
			const rows = result.map(({ tableName, tbComment, colName, colComment, ...row }) => ({
				...row,
				tableName,
				tbComment,
				colName,
				colComment
			}));

			//console.log('select_ 진행 후 넘어온 데이터', rows);
			//commit('setTableInfoList', res.body.resultList);
			commit('setTableInfoList', rows);
			commit(types.SET, { key: 'pagingInfo', value: pagingInfo });
			return rows;
		});
	}
	/* */
	/*
	onChangeSearchParam_({ state, commit, dispatch }, payload) {
		commit(types.SET_SEARCH_PARAM, payload);
		if (['commCdType', 'useYn'].includes(payload.key)) {
			return dispatch('searchCommCdType_', { ...state.commCdTypePagingInfo, currentPage: 1 });
		}
	},
	*/
};
